const sliders = document.querySelectorAll<HTMLElement>('.post-slider');

sliders.forEach((slider) => {
	const breakpoints = {
		[window.impBreakpoints?.xs ?? 0]: {
			slidesPerView: 1.1,
			spaceBetween: 16,
		},
		[window.impBreakpoints?.md ?? 768]: {
			slidesPerView: 2.1,
			spaceBetween: 40,
		},
		[window.impBreakpoints?.lg ?? 992]: {
			slidesPerView: 3.1,
			spaceBetween: 40,
		},
		[window.impBreakpoints?.xxl ?? 1304]: {
			slidesPerView: 3,
			spaceBetween: 40,
		},
	};

	new (window as Window).Swiper(slider, {
		navigation: {
			nextEl: '.slider-pagination__button--next',
			prevEl: '.slider-pagination__button--prev',
			disabledClass: 'slider-pagination__button--disabled',
		},
		breakpoints,
	});
});
